import { ItemMappingDetailPage } from "@/features/item-mapping/pages/ItemMappingDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/item-mapping/$id/detail")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <ItemMappingDetailPage id={id} />;
}
